import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { RestUserResponse, RestUsersResponse } from './types.tsx';

export const MAX_USERS = 5;

// Endpoints

export const getUserBaseEndpoint = (): string => '/rest/api/2/user';

export const getUserFullEndpoint = (accountId = ''): string =>
	`${getUserBaseEndpoint()}?accountId=${encodeURIComponent(accountId)}`;

export const getUsersBaseEndpoint = (): string => '/rest/api/2/user/picker';

export const getUsersFullEndpoint = (query = ''): string =>
	`${getUsersBaseEndpoint()}?showAvatar=true&maxResults=${MAX_USERS}&query=${query}`;

// Requests

export const getUser = (accountId = ''): Promise<RestUserResponse> =>
	fetchJson(getUserFullEndpoint(accountId));

export const getUsers = (query = ''): Promise<RestUsersResponse> =>
	fetchJson(getUsersFullEndpoint(query));
